<!--
 * @Author: zxf
 * @Date: 2022-08-03 18:10:27
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 18:32:04
 * @Description: 消防设备登记
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        消防设备管理
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />
        <k-button
          btn-text="其他说明"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-file-text"
          plain
          @click="handleDialog('qtsm')"
        />
        <template v-if="showType === 'edit'">
          <k-button
            btn-text="新增"
            :auth-type="true"
            type="success"
            icon="kestrel-icon ki-plus"
            @click="handleDialog('add')"
          />

          <import-upload
            ref="fduploadsbxx"
            accept="xlsx,xls"
            :action="`${importUrl}`"
            success-alert-msg="导入成功"
            class="u-inline-block u-mg-l-8"
          />
          <k-button
            btn-text="导入"
            :auth-type="true"
            type="primary"
            icon="kestrel-icon ki-import"
            plain
            @click="handlePreview"
          />
          <k-button
            btn-text="模板下载"
            :auth-type="true"
            type="primary"
            icon="kestrel-icon ki-cloud-download"
            plain
            @click="handleDownload()"
          />
        </template>
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="90px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="系统名称"
                prop="xtsbMc"
              >
                <select-sb
                  v-model="filterParams.xtsbMc"
                  clearable
                  type="jc"
                  show-all
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table
            ref="kTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template
              #xfsbmc="scope"
            >
              <el-link
                type="primary"
                @click="handleDialog('view', {id: scope.row.xfsbdjId})"
              >
                {{ scope.row.xfsbmc }}
              </el-link>
            </template>
            <template
              #hgz="scope"
            >
              {{ scope.row.hgz === 'Y'?'合格':scope.row.hgz === 'N'?'不合格':'' }}
            </template>

            <el-table-column
              v-if="showType === 'edit'"
              prop="enabled"
              label="操作"
              width="100"
              align="center"
              fixed="right"
            >
              <template
                slot-scope="scope"
              >
                <!-- <k-button
          btn-text="导出"
:auth-type="false"
                  type="primary"
                  plain
                  @click="openNavTab({ name: 'robotWorkerLog', params: { logId: scope.row.id } })"
                >
                  编辑
                </k-button> -->
                <k-button
                  btn-text="删除"
                  :auth-type="true"

                  type="danger"
                  @click="handleDel(scope.row, scope.$index)"
                />
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 页面主内容：查询列表 End -->

    <!-- 其他说明 -->
    <jcsb-qtsm-dialog
      v-if="showDialogName==='qtsm'"
      :xm-id="xmId"
      :show-type="showType"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />

    <!-- 设备录入 -->
    <jcsb-add-dialog
      v-if="showDialogName==='add'"
      :xm-id="xmId"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />

    <!-- 设备查看 -->
    <jcsb-view-dialog
      v-if="showDialogName==='view'"
      :dl-params="dialogParams"
      :xm-id="xmId"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />
  </div>
</template>

<script>
import { xfsbService } from './xfsb.service';
import JcsbQtsmDialog from './qtsmDialog.vue';
import JcsbAddDialog from './addDialog.vue';
import JcsbViewDialog from './viewDialog.vue';

export default {
  name: 'XfsbIndex',
  components: {
    JcsbQtsmDialog,
    JcsbAddDialog,
    JcsbViewDialog
  },
  data () {
    return {
      loading: false, // 页面是否loading状态
      xmId: '', // 项目ID
      dialogParams: {}, // 弹窗参数
      importUrl: '',
      upLoadText: null,
      showType: null, // 显示类型，查看：view、编辑：edit

      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        xmId: null,
        xtsbMc: null, // 系统设备名称
        xtmc: null, // 系统名称
        sbmc: null // 设备名称
      },
      /* 查询条件 end */

      /** 弹窗参数 START */
      showDialogName: '',
      /** 弹窗参数 END */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'xfxtmc', label: '系统名称', align: 'left', minWidth: '150', type: 'text' },
        { key: 'xfsbmc', slotName: 'xfsbmc', label: '设备名称', align: 'left', minWidth: '180', type: 'text' },
        { key: 'xfsbsl', label: '数量', align: 'center', width: '60', type: 'text' },
        { key: 'xfsbxh', label: '产品型号/生产厂家', align: 'left', minWidth: '180', type: 'text' },
        { key: 'xfsbzmwj', label: '符合法定市场准入规则的证明文件', align: 'left', minWidth: '130', type: 'text' },
        { key: 'hgz', slotName: 'hgz', label: '合格证', align: 'center', width: '60', type: 'text' },
        { key: 'ccrq', label: '出厂日期', align: 'center', width: '90', type: 'date' },
        { key: 'bz', label: '备注', align: 'left', width: '200', type: 'text' }
      ]
      /* 表格列配置End */

    };
  },
  methods: {
    /**
     * @description: 文件导入成功后操作
     * @return {*}
     */
    handleImportSuccess () {
      const _this = this;
      _this.$alert('导入成功！', '提示', {
        confirmButtonText: '确定',
        type: 'success',
        callback: action => {
          _this.refreshSearch();
        }
      });
    },
    /**
     * @description: 触发上传按钮
     * @return {*}
     */
    submitUpload () {
      this.upLoadText = {
        creator: window.sessionStorage.getItem('accountName'),
        fileName: this.fileName,
        requirement: this.selectedRequirement
      };
      console.log(this.$refs.fduploadsbxx);
      this.$refs.fduploadsbxx.handleClick();
      this.loading = false;
    },
    /**
     * @description: 文件上传前处理
     * @return {*}
     */
    handlePreview () {
      const _this = this;
      const h = this.$createElement;
      this.$confirm('提示', {
        title: '提示',
        message: h('div', [h('p', '1、请使用模板导入设备信息，表中数据均为必填信息。'), h('p', '2、为保证成功，请根据表中数据格式及字段顺序依次填写。')]),
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          _this.loading = true;
          _this.submitUpload();
        }).catch(() => {
        });
      _this.loading = false;
    },
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _parmas) {
      this.showDialogName = _name;
      this.dialogParams = _parmas;
    },
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      if (this.filterParams.xtsbMc && this.filterParams.xtsbMc.includes('/')) {
        [this.trueFilterParams.xtmc, this.trueFilterParams.sbmc] = this.filterParams.xtsbMc.split('/');
      }
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */
      this.loading = true;
      xfsbService.queryXfsb(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields(); ;
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm(`是否确认删除此设备信息：${_row.xfsbmc}？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        xfsbService.deleteXfsb(_row.xfsbdjId)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },

    /**
     * @description: 点击下载
     * @param {*}
     * @return {*}
     */
    handleDownload () {
      this.loading = true;
      xfsbService.exportSbmbFile()
        .then((rsp) => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('设备模板下载出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created () {
    this.xmId = this.$route.params.xmId;
    this.filterParams.xmId = this.$route.params.xmId;
    this.importUrl = this.$config.ctx.iffApi + `/xfjc/jcsb/${this.xmId}/import`;
    this.refreshSearch();
  },
  activated () {
    this.xmId = this.$route.params.xmId;

    this.showType = this.$route.params.type;

    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>
